import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import HeroBanner from 'ui/home/HeroBanner';
import LatestArbitrumL2Batches from 'ui/home/latestBatches/LatestArbitrumL2Batches';
import LatestZkEvmL2Batches from 'ui/home/latestBatches/LatestZkEvmL2Batches';
import LatestBlocks from 'ui/home/LatestBlocks';
import Stats from 'ui/home/Stats';
import Transactions from 'ui/home/Transactions';

const rollupFeature = config.features.rollup;

const Home = () => {

  const leftWidget = (() => {
    if (rollupFeature.isEnabled && !rollupFeature.homepage.showLatestBlocks) {
      switch (rollupFeature.type) {
        case 'zkEvm':
          return <LatestZkEvmL2Batches/>;
        case 'arbitrum':
          return <LatestArbitrumL2Batches/>;
      }
    }

    return <LatestBlocks/>;
  })();

  return (
    <Box as="main">
      <HeroBanner/>
      { /* Stats Card - overlaps banner with negative margin */ }
      <Box
        mt={{ base: '-40px', lg: '-70px' }}
        position="relative"
        zIndex={ 0 }
      >
        <Box
          bg="white"
          borderRadius="12px"
          boxShadow="0 0.5rem 1.2rem rgba(189,197,209,0.2)"
          border="1px solid"
          borderColor="card_border"
          overflow="hidden"
        >
          <Stats/>
        </Box>
      </Box>
      <Flex mt={ 8 } direction={{ base: 'column', lg: 'row' }} columnGap={ 6 } rowGap={ 6 }>
        <Box flex="1" minW="0">
          { leftWidget }
        </Box>
        <Box flex="1" minW="0">
          <Transactions/>
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;